import React from 'react'
import { NavLink } from 'react-router-dom'

import '../styles/nav.scss'

function Nav() {
  return (
    <div className="account-nav">
      <div className="account-nav__wrap">
        {[
          { link: '/account', title: 'Подписки' },
          { link: '/account/edit', title: 'Профиль' }
        ].map((item, index) => (
          <NavItem {...item} key={index} />
        ))}
      </div>
    </div>
  )
}

export default React.memo(Nav)

const NavItem = React.memo(({ link, title }) => (
  <NavLink exact to={link} className="account-nav__item" activeClassName="account-nav__item--active">
    {title}
  </NavLink>
))
